<template>
<div>
  <div class="row">
    <div class="col-md-12">
      <h4>Meios de arrecadar</h4>
      <span>Receba doações com simplicidade e segurança utilizando o Paypal.</span>
    </div>
  </div>

  <div class="row">

    <div class="col-md-6">
      Utilize o PayPal para pagamentos recorrentes, aceitando cartões de crédito e débito do mundo inteiro.<br><br>
      <a href="https://www.paypal.com/br/webapps/mpp/account-selection" target="_blank">Crie uma conta no PayPal</a>
    </div>

    <div class="col-md-6">
        <!-- <h4>PagSeguro</h4>
        <div class="row">
          <div class="form-group col-md-6">
            <label>Token</label>
            <input class="form-control" type="password" v-model="pagseguroToken" />
          </div>
          <div class="col-md-6">
            Receba doações fácil e rápido. 
            Acesse nosso tutorial no link:<br><br>
            <a href="https://click2giv.helpscoutdocs.com/article/7-integracao-com-pagseguro" target="_blank">Guia de integração com o PagSeguro.</a>
          </div>
          <div class="form-group col-md-6">
            <label>E-mail</label>
            <input class="form-control" type="text" v-model="pagseguroEmail" />
          </div>
          <div class="col-md-6">
            
          </div>
        </div> -->
        <h4>Habilitar PayPal</h4>
        <div class="form-group mt-2">
          <label>E-mail</label>
          <input class="form-control" type="text" v-model="paypalEmail"/>
        </div>
    </div>
  </div>

  <div class="row">

    <div class="col-md-6 instructions">
      <b>Você pode habilitar também o pagamento com cartões de crédito através do Checkout Transparente do PayPal.</b><br>
      <span>Basta seguir o passo a passo abaixo</span>

      <div class="step">
        <h3>1</h3>
        <span>Entre em contato com a nossa central de atendimento através do 0800 047 4482</span>
      </div>

      <div class="step">
        <h3>2</h3>
        <span>Solicite a liberação do PayPal Plus na conta mediante a aprovação do produto.</span>
      </div>

      <div class="step">
        <h3>3</h3>
        <span>Retorne para a Click2Giv após receber a confirmação da aprovação para configurar o produto, conforme o passo a passo fornecido pela Click2Giv.</span>
      </div>
    </div>

    <div class="col-md-6 plus-form">
      <a target="_blank" href="https://s3-sa-east-1.amazonaws.com/new.click2giv.com/paypal-credentials.pdf">Clique aqui</a> para acessar o passo a passo para gerar credenciais de Api.<br><br>
      <span>Credenciais</span>
      <div class="form-group mt-2">
        <label>Client Id:</label>
        <input class="form-control" type="text" v-model="paypalClientId"/>
      </div>
      <div class="form-group mt-2">
        <label>Secret:</label>
        <input class="form-control" type="text" v-model="paypalSecret"/>
      </div>

      <p>Para utilizar o Checkout Transparente é preciso ter o pagamento recorrente habilitado também.</p>
    </div>

  </div>

  <div class="row">
    <div class="col-md-4">
      <button v-on:click.stop.prevent="save()" class="btn">Salvar Alterações</button>
    </div>
    <div class="col-md-8">
      <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
        {{msg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div v-if="showSuccessMsg" class="alert alert-success alert-dismissible fade show" role="alert">
        {{successMsg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'

export default {
  name: 'ProjectOther',
  props: ['project'],
  components: {

  },
  data(){
    return {
      msg: '',
      showMsg: false,
      successMsg: '',
      showSuccessMsg: false,
      pagseguroToken: null,
      pagseguroEmail: null,
      paypalEmail: null,
      paypalClientId: null,
      paypalSecret: null,
      projectId: null,
      page: 'other'
    }
  },
  mounted(){
    this.projectId = this.project.ProjectId;
    // if(this.project.PagseguroAccount){
    //   this.pagseguroToken = this.project.PagseguroAccount.token;
    //   this.pagseguroEmail = this.project.PagseguroAccount.email;
    // }
    if(this.project.PaypalAccount){
      this.paypalEmail = this.project.PaypalAccount.email;
      this.paypalClientId = this.project.PaypalAccount.clientId;
      this.paypalSecret = this.project.PaypalAccount.secret;
    }
  },
  methods: {
    save(){
      this.$emit('showloading');
      // this.$http.post(API.Projects.updateProject + this.projectId, {page: this.page, pagseguroToken: this.pagseguroToken, pagseguroEmail: this.pagseguroEmail,
      this.$http.post(API.Projects.updateProject + this.projectId, {page: this.page, paypalEmail: this.paypalEmail, paypalClientId: this.paypalClientId, paypalSecret: this.paypalSecret},
      {headers: auth.getHeaders()})
        .then((res) => {
          if(res.body.success === true){
            this.successMsg = res.body.message;
            this.showSuccessMsg = true;
          }else{
            this.showMessage(res.body.message);
          }
          this.$emit('hideloading');
        }, (err) => {
          this.showMessage('Erro ao processar requisição.');
          this.$emit('hideloading');
        });
    },
    showMessage(msg){
      this.msg = msg;
      this.showMsg = true;
    },
    hideMessage(){
      this.successMsg = "";
      this.msg = "";
      this.showMsg = false;
      this.showSuccessMsg = false;
    },
  }
}
</script>

<style lang="scss" scoped>
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}
.row{
  margin-bottom: 20px;
}
a{
  text-decoration: none;
  color: #00AE39;
  font-family: RalewayBold;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
.instructions{
  b{
    font-family: RalewayBold;
  }
  span{
    color: #17a2b8;
    font-family: RalewayBold;
  }

  .step{
    display: block;
    width: 100%;
    margin-top: 10px;
    min-height: 70px;

    h3{
      color: #17a2b8;
      font-size: 54px;
      display: block;
      float: left;
      width: 10%;
    }

    span{
      display: block;
      float: right;
      width: 85%;
      color: #333;
      font-family: RalewayRegular;
      margin-top: 10px;
    }
  }
}
.plus-form{
  a{
    color: #00AE39;
  }
  span{
    color: #17a2b8;
    font-family: RalewayBold;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manage-project/Other.vue